import getEnv from 'helpers/getEnv';

const ENV = {
  REACT_APP_CARGA_INDICADORES_ON: getEnv('REACT_APP_CARGA_INDICADORES_ON') === 'true',
};

export default ENV;
